import { Button, Th, Tooltip } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { Eye } from 'phosphor-react';
import { useTheme } from 'styled-components';

interface IViewAction {
  viewAction: Function;
  log: any;
  endpoint: string;
}

export default function ViewAction({ viewAction, log, endpoint }: IViewAction) {
  const { t } = useTranslation('tables');
  const theme = useTheme();

  return (
    <Th w={'100px'} textAlign={'start'}>
      <Tooltip label={t(`common.view`)}>
        <Button
          color={theme.form.color}
          isDisabled={!log.isActive && endpoint === 'users'}
          onClick={() => {
            viewAction(log);
          }}
          fontSize={14}
          variant={'ghost'}
          _hover={{ bg: 'none' }}
          p={'0'}
        >
          <Eye size={21} />
        </Button>
      </Tooltip>
    </Th>
  );
}
